/**
 * Client-generated key sent as the `Idempotency-Key` header. The backend dedupes
 * on (workspace_id, user_id, key) and replays the original response, so a retry
 * after a dropped connection can never create a duplicate visit report.
 */
export const newIdempotencyKey = (): string => {
  const cryptoObj = window.crypto as Crypto & { randomUUID?: () => string };
  if (cryptoObj?.randomUUID) return cryptoObj.randomUUID();
  if (cryptoObj?.getRandomValues) {
    const bytes = cryptoObj.getRandomValues(new Uint8Array(16));
    return Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
  }
  // Last resort (very old Safari over plain http): still unique enough per device.
  return `${Date.now().toString(16)}-${Math.random().toString(16).slice(2)}`;
};
